import TnCSection from "../../Sections/TnCSection";

const TnCComponentComponent = () => {
  return <TnCSection />;
};

export default TnCComponentComponent;
